import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dispatcherwithoutaddress" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "border bg-white px-6 py-4" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_orders_without_address_list_item = _resolveComponent("orders-without-address-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data_state.orders.is_failed && !_ctx.data_state.orders.failure.error_state.is_cancel)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.data_state.orders.is_loading,
          text: "При получении заказов без адреса произошла ошибка",
          "error-message": _ctx.data_state.orders.failure.error_state.message,
          "error-url": _ctx.data_state.orders.failure.error_state.url,
          "error-status": _ctx.data_state.orders.failure.error_state.status,
          onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadOrdersWithoutAddress(_ctx.data_state.orders.pagination.current_page)))
        }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_the_select, {
              value: _ctx.filters_state.sender_city_id,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.sender_city_id) = $event)),
              placeholder: "Поиск по городу",
              loading: _ctx.data_state.cities.is_loading,
              options: _ctx.data_state.cities.list,
              failed: _ctx.data_state.cities.is_failed,
              "error-text": "При получении списка городов произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              "infinite-scroll": "",
              onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
              onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
              onSearch: _ctx.searchCity,
              onOptionBySearch: _ctx.unshiftFindedCity
            }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_button, {
                class: "second small text mr-3",
                loading: _ctx.data_state.orders.is_loading,
                onClick: _ctx.resetFilters
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary small mr-3",
                loading: _ctx.data_state.orders.is_loading,
                onClick: _ctx.applyFilters
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _createVNode(_component_list, {
            class: "mt-6",
            loading: _ctx.data_state.orders.is_loading,
            items: _ctx.data_state.orders.list,
            pagination: "",
            "pagination-current-page": _ctx.data_state.orders.pagination.current_page,
            "pagination-total-pages": _ctx.data_state.orders.pagination.total_pages,
            onChangePage: _ctx.loadOrdersWithoutAddress
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_orders_without_address_list_item, {
                item: item,
                "set-disabled": _ctx.dispatcher_map.setting_address_state.is_setting,
                onSetAddress: _ctx.startSetAddress
              }, null, 8, ["item", "set-disabled", "onSetAddress"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"])
        ]))
  ]))
}